import axios from 'axios';
import { moment } from 'i18n';
import qs from 'qs';
import { backendUrl } from 'setup';

const history = {};

const resolutions = {
  '1': '1',
  '5': '5',
  '15': '15',
  '30': '15',
  '60': '60',
  '240': '240',
  '1D': '1440',
  D: '10080',
};

const historyProvider = {
  history: history,

  getBars: async (symbolInfo, resolution, from, to, first, limit) => {
    const split_symbol = symbolInfo.name.split(/[:/]/);
    const queryString = qs.stringify({
      baseCurrency: split_symbol[0],
      quoteCurrency: split_symbol[1],
      timestamp: first
        ? moment
            .unix(to)
            // .subtract(1, 'm')
            .valueOf()
        : to * 1000,
      interval: resolutions[resolution],
      limit: limit ? limit : 1000,
    });

    let response;
    try {
      response = await axios({
        url: `${backendUrl}/market/get-chart-data?${queryString}`,
        method: 'GET',
      });
    } catch {
      return [];
    }

    const payload = response?.data;
    const rows = Array.isArray(payload?.data) ? payload.data : [];
    if (payload?.status === 'Error' || rows.length === 0) {
      return [];
    }

    const bars = rows.map((bar) => {
      delete bar.ID;
      return { ...bar, time: moment(bar.time).valueOf() };
    });

    if (first) {
      history[symbolInfo.name] = { lastBar: bars[0] };
    }

    return bars.reverse();
  },
};

export default historyProvider;
